// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__12A5t","right":"styles_right__3qfXU"};